import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RevenueObservationService {
  private _newPaymentSubject = new Subject();
  private _invoiceAmountChangedSubject = new Subject<number>();
  private _invoiceBalance = new BehaviorSubject<number>(0);
  private _invoiceLoadedSubject = new Subject();
  private _requestInvoiceUpsertSubject = new Subject();

  constructor() {}

  public observeNewPayments(): Observable<any> {
    return this._newPaymentSubject.asObservable();
  }

  public observeInvoiceAmountChanged(): Observable<number> {
    return this._invoiceAmountChangedSubject.asObservable();
  }

  public $invoiceBalance(): Observable<number> {
    return this._invoiceBalance.asObservable();
  }

  public newPayment() {
    this._newPaymentSubject.next(null);
  }

  public invoiceAmountChanged(invoiceNum: number) {
    this._invoiceAmountChangedSubject.next(invoiceNum);
  }

  public updateBalance(balance: number) {
    this._invoiceBalance.next(balance);
  }

  public observeInvoiceLoaded(): Observable<any> {
    return this._invoiceLoadedSubject.asObservable();
  }

  public observeRequestInvoiceUpsert(): Observable<any> {
    return this._requestInvoiceUpsertSubject.asObservable();
  }

  public invoiceLoaded() {
    this._invoiceLoadedSubject.next(null);
  }

  public requestInvoiceUpsert() {
    this._requestInvoiceUpsertSubject.next(null);
  }
}
